import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row } from 'react-bootstrap';
import Ledger from './ledger';
import { loadTimersFromFirebase } from './timer_actions';
import { createPdf } from '../../common/common_actions';
import firebaseApp from '../../firebase/firebase';

class TimeTracker extends Component {
  constructor(){
    super();
    this.state = {
      hours: 0
    }
  }
    componentDidMount() {
        this.props.loadTimersFromFirebase();
        this.handleExportClick = this.handleExportClick.bind(this);
        firebaseApp.database().ref(`users/${this.props.user.uid}`).on('value', snapshot => {
          this.setState({ realtor: snapshot.val().meta.realtor, hours: snapshot.val().meta.hours })
        })
    }

    handleExportClick() {
        const htmlToConvert = this.timeTracker.outerHTML;
        this.props.createPdf(htmlToConvert, 'ledger.pdf');
    }

    render() {
        const { allTimers } = this.props;
        return (
            <div ref={(element) => { this.timeTracker = element; }}>
              <Grid fluid style={{ marginBottom: 120, borderRadius: 10 }}>
                <Row>
                  {
                    (allTimers.length === 0) ?
                    <span>Ledger is empty.</span> :
                    <Ledger timers={allTimers} realtor={this.state.realtor} agentHours={this.state.realtor? this.state.hours: 0 } style={{'backgroundColor': 'white'}} exportPDF={this.handleExportClick} />
                  }
                </Row>
              </Grid>
            </div>
        );
    }
}

function mapStateToProps({timer, auth}) {
    const { allTimers } = timer;
    const { user } = auth
    return { allTimers, user};
}

function mapDispatchToProps(dispatch) {
    return {
        loadTimersFromFirebase: () => dispatch(loadTimersFromFirebase()),
        createPdf: (html, name) => dispatch(createPdf(html, name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeTracker);



// WEBPACK FOOTER //
// ./src/components/timetracker/index.jsx